import axios from "axios";
import auth from "../util/loginUtil";
import { toLogin } from "@/router/router";
import { MessageBox } from "element-ui";

// axios 配置
axios.defaults.timeout = 400000;

// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] = auth.getToken();
    config.headers["Pragma"] = "no-cache"; // 防止ie下get方法缓存
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.request.responseType === "blob" || response.request.responseType === "arraybuffer") {
      return Promise.resolve(response);
    }
    let data = response.data;

    if (response.data) {
      if (!response.data.success) {
        MessageBox.confirm(data.message, "错误", {
          type: "error",
          showCancelButton: false,
        });
      }
    }

    if (data) {
      return Promise.resolve(data);
    }
  },
  (error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        MessageBox.confirm("未认证或者认证过期，请重新登录", "错误", {
          type: "error",
          showCancelButton: false,
        });
        auth.logout();
        toLogin();
        return Promise.reject(error);
      }
      if (error.request.responseType === "blob") {
        const { data } = error.response;
        const reader = new FileReader();
        reader.onload = () => {
          const errorInfos = JSON.parse(reader.result);
          MessageBox.confirm(errorInfos.message, "错误", {
            type: "error",
            showCancelButton: false,
          });
        };
        reader.onerror = (err) => {
          return Promise.reject(err);
        };
        reader.readAsText(data);
      } else {
        console.log(error.response.data);
        if (error.response.data.status === 404) {
          MessageBox.confirm("status:" + error.response.data.status + "未找到接口:" + error.response.data.path, "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          MessageBox.confirm(error.response.data.message, "错误", {
            type: "error",
            showCancelButton: false,
          });
        }
      }
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
      MessageBox.confirm("连接服务器失败", "错误", {
        type: "error",
        showCancelButton: false,
      });
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error", error.message);
      MessageBox.confirm("请求服务器出错", "错误", {
        type: "error",
        showCancelButton: false,
      });
    }
    console.log("-------------接口请求错误信息end-------------");
    return Promise.reject(error);
  }
);

export default axios;
